import _generalNodate from "@zenlayer/zen-design-icons/assets/general/Nodate.svg";
import classNames from 'classnames';
import Spin from '../spin';
import Icon from '../icon';
import { useTheme } from '../hooks/useThemeSwitch';
import React from 'react';
import { useConfig } from '../hooks/useConfig';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const NotFoundContent = _ref => {
  let {
    optionsLoading
  } = _ref;
  const [theme, colors] = useTheme();
  const {
    locale: {
      Select: SelectLocale
    }
  } = useConfig();
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      color: colors['--zen-design-onSurface-low-color']
    },
    children: optionsLoading ? /*#__PURE__*/_jsx(Spin, {}) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "general/Nodate",
        fontSize: 48
      }), /*#__PURE__*/_jsx("span", {
        children: SelectLocale.noData
      })]
    })
  });
};
export const Tag = props => {
  const {
    text,
    size = 'm'
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('select-item-tag', size),
    children: text
  });
};
export const SelectItem = props => {
  const {
    name,
    suffix
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "select-item",
    children: [/*#__PURE__*/_jsx("span", {
      className: "name",
      children: name
    }), suffix]
  });
};